/* eslint-env browser */
import scroll from './smoothScroll';

export function scrollToElement(selector, duration, offsetSelector, scrollToBottom) {
  if (typeof window === 'undefined') {
    return;
  }

  const element = selector.nodeName ? selector : document.querySelector(selector);
  if (!element) {
    return;
  }
  const offsetNode = document.querySelector(offsetSelector);
  const offsetHeight = offsetSelector && offsetNode ? offsetNode.clientHeight : 0;
  const rect = element.getBoundingClientRect();
  const body = document.body;
  const docElem = document.documentElement;
  const scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
  const clientTop = docElem.clientTop || body.clientTop || 0;
  let top = rect.top + scrollTop - clientTop - offsetHeight;
  if (scrollToBottom) {
    const vHeight = docElem.clientHeight || body.clientHeight || window.innerHeight;
    top -= vHeight - rect.height - 10;
  }
  return scroll({ y: Math.round(top) }, duration);
}
